import { useState } from 'react'
import classNames from 'classnames'
import Modal from 'react-bootstrap/Modal'
import { DISHtml } from 'shared'

export const TaxNotice = (props) => {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return <>
    <DISHtml value={I18n.t('shared.tax_deductibility_notice_html')} onClick={handleShow} className={classNames(props.additionalClassName)}/>
    <Modal className='generic-modal-window' show={show} onHide={handleClose}>
      <Modal.Body>
        <p>
          <DISHtml value={I18n.t('shared.tax_deductibility_modal_html')}/>
        </p>
        <div className='text-right'>
          <a className='btn btn-primary' onClick={handleClose}>{I18n.t('misc.close')}</a>
        </div>
      </Modal.Body>
    </Modal>
  </>
}
